export default {
  text: 'Bei {{provider}} verifizieren',
  text_generic: 'Beim Zahlungsanbieter verifizieren',
  error: 'Das Formular von {{provider}} konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',
  error_generic: 'Das Formular des Zahlungsanbieters konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.',
  providers: {
    stripe: 'Stripe',
    adyen: 'Adyen',
  },
};
